export default function Intro() {
  return (
    <section className="py-20 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left — image */}
          <div className="w-full h-[460px] rounded-2xl overflow-hidden bg-gray-100 flex-shrink-0">
            <img
              src="/assets/img/e38bc578db7c.webp"
              alt="Custom printed skin on a stretch tent, close up"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Right — text */}
          <div>
            <p className="text-teal-500 text-sm font-semibold tracking-widest uppercase mb-3">
              Custom Skins
            </p>
            <h2 className="text-4xl font-extrabold text-gray-900 leading-snug mb-6">
              Your brand. Your vision. <br /> On a grand scale.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Elevate your event with a fully custom-printed skin for your stretch tent. Welcome to a realm of limitless creativity where your event becomes a masterpiece of personalised design. Our custom skins deliver an unrivalled WOW factor, perfect for brand activations, product launches, and sponsored events.
            </p>
            <div className="flex flex-wrap gap-3">
              {['Full-Color Print', 'High-Res Graphics', 'Dye-Sublimation', 'Any Design'].map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-1.5 bg-teal-50 text-teal-600 text-sm font-semibold rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
